import styles from '@/styles/myAccountLayout.module.scss'
import Link from 'next/link'
import { useState, useEffect } from "react"
import { useRouter } from 'next/router'
import myAccountApi from '@/service/modules/myAccountApi'
import AddressSvg from "@/svgs/myaccount/Menu-Address.svg"
import ContactSvg from "@/svgs/myaccount/Menu-Contact.svg"
import CreditsSvg from "@/svgs/myaccount/Menu-Credits.svg"
import LoginDetailsSvg from "@/svgs/myaccount/Menu-LoginDetails.svg"
import MystatusSvg from "@/svgs/myaccount/Menu-Status.svg"
import OrderSvg from "@/svgs/myaccount/Menu-Order.svg"
import WishlistSvg from "@/svgs/myaccount/Menu-Wishlist.svg"
import { Button, Layout } from 'antd'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
const { Sider } = Layout;

interface props {
  children: React.ReactNode
  statusID?: number
  refreshList?: Function
}

export default function MyAccountLayout({ children, statusID, refreshList }: props) {
  const router = useRouter()
  const { asPath } = router
  const currentPath = asPath;


  interface dataInterface {
    customerID: number,
    firstName: string,
    lastName: string,
    level: number,
    valuedCustomer: string
  }
  const [customerData, setCustomerData] = useState<dataInterface | null>(null)
  // 获取用户信息
  const getCustomerInfo = async () => {
    try {
      let res = await myAccountApi.getCustomerInfo()
      if (res.data) {
        const data = {
          customerID: res.data?.customer.customerID,
          firstName: res.data?.customer.firstName,
          lastName: res.data?.customer.lastName,
          level: res.data?.customer.level,
          valuedCustomer: res.data?.valuedCustomer
        }
        setCustomerData(data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  // myaccount菜单
  const defaultMenuList = [
    {
      name: 'Order History', link: `/myaccount/order/0`, icon: <OrderSvg  />,
      items: [
        {
          name: 'Show All',
          link: '/myaccount/order/0',
          statusID: 0
        },
        {
          key: 'pending',
          name: 'Pending',
          link: '/myaccount/order/2',
          statusID: 2
        },
        {
          key: 'processing',
          name: 'Processing',
          link: '/myaccount/order/3',
          statusID: 3
        },
        {
          key: 'sent',
          name: 'Sent',
          link: '/myaccount/order/4',
          statusID: 4
        },
        {
          key: 'cancelled',
          name: 'Cancelled',
          link: '/myaccount/order/1',
          statusID: 1
        },
        {
          key: 'onHold',
          name: 'On Hold',
          link: '/myaccount/order/5',
          statusID: 5
        },
        {
          key: 'unreviewed',
          name: 'Awaiting Reviewed',
          link: '/myaccount/order/7',
          statusID: 7
        },
        {
          key: 'reviewed',
          name: 'Reviewed',
          link: '/myaccount/order/6',
          statusID: 6
        }
      ]
    },
    { name: 'My Wishlist', link: `/myaccount/wishlist`, icon: <WishlistSvg /> },
    { name: 'Contact Information', link: `/myaccount`, icon: <ContactSvg  /> },
    { name: 'Address Manager', link: `/myaccount/address`, icon: <AddressSvg  /> },
    { name: 'Credits & Points', link: `/myaccount/credits`, icon: <CreditsSvg  /> },
    { name: 'Login Details', link: `/myaccount/logindetails`, icon: <LoginDetailsSvg  /> },
    { name: 'My Status', link: `/myaccount/status`, icon: <MystatusSvg  /> },
  ]
  const [menuList] = useState(defaultMenuList)
  const [orderCounts, setOrderCounts] = useState<any>({
    "cancelled": 0,
    "pending": 0,
    "processing": 0,
    "sent": 0,
    "onHold": 0,
    "unreviewed": 0,
    "reviewed": 0
  })


  // 获取orderList各个状态的订单数量
  const getOrderStart = async () => {
    try {
      const res = await myAccountApi.getOrderStart()
      const menuList = res.data.stat
      setOrderCounts(menuList)
    } catch (error) {
      console.log(error);

    }
  }

  const [collapsed, setCollapsed] = useState(true);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  useEffect(() => {
    getCustomerInfo()
    getOrderStart()
  }, [])

  // 判断当前路径是否与菜单的link匹配
  function isActive(link: string, isParent?: boolean) {
    // 如果link末尾是动态的（例如 /order/0），则只检查路径的前部分
    const listLink = '/myaccount/order/'
    const detailLink = '/myaccount/orderdetails/'
    if (
      (currentPath.startsWith(listLink) && link.startsWith(listLink)) ||
      (currentPath.startsWith(detailLink) && link.startsWith(listLink))
    ) {
      // 检查路径是否匹配，如以 `/myaccount/order/` 开头
      if (isParent) {
        return true
      }

      return currentPath === link;
    }
    // 其他情况下，完全匹配
    return currentPath === link;
  }

  return (
    <div className={styles['my-account-layout']}>
      <div className={styles['wapper']}>
        {/* header部分 */}
        <div className={styles['my-account-header']}>
          <div className={styles["title-text"]}>
            <Button onClick={toggleSidebar} className={styles.menuBtn} >
              Menu
              {collapsed ? <CaretLeftOutlined /> : <CaretRightOutlined />}
            </Button>
            My Account
          </div>
          {
            !!(customerData && customerData.customerID) &&
            <div className={styles['customer-info']}>
              <div className={styles["customer-name"]}>Hi&nbsp;{customerData.firstName ? `${customerData.firstName} ${customerData.lastName ? customerData.lastName : ''}` : 'Customer'}</div>
              <div className={styles["customer-level"]}>
                Valued Customers：
                <Link
                  href={'/article/faq'}
                  passHref
                  legacyBehavior
                >
                  <a className={styles["customer-level-value"]} rel="noopener noreferrer">
                    {customerData.valuedCustomer} (level {customerData.level})
                  </a>
                </Link>
              </div>
            </div>
          }
        </div>

        {/* 主要内容 */}
        <div className={styles['my-account-box']}>

          {/* 侧边栏 */}
          <div className={styles['slider-pc']}>
            <MenuList
              menuList={menuList}
              isActive={isActive}
              statusID={statusID}
              router={router}
              refreshList={refreshList}
              orderCounts={orderCounts}
            />
          </div>

          <div className={styles['slider-ipad']}>
            <Sider
              width={224}
              className={`${styles.sidebar} ${collapsed ? styles.hide : styles.show}`}
              trigger={null}
              collapsible
            >
              <MenuList
                menuList={menuList}
                isActive={isActive}
                statusID={statusID}
                router={router}
                refreshList={refreshList}
                orderCounts={orderCounts}
              />
            </Sider>
          </div>


          <div className={`${styles.content} ${collapsed ? styles.expand : styles.shrink}`} onClick={()=>{!collapsed && setCollapsed(true)}}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

const MenuList = ({ menuList, isActive, statusID, router, refreshList, orderCounts }: any) => (
  <div className={styles['slider-list']}>
    {
      menuList.map((menu: any) =>
        <div key={menu.name}>
          <Link
            href={menu.link}
            passHref
            legacyBehavior
          >
            <a title={menu.name} rel="noopener noreferrer">
              <div className={`${styles['slider-item']} ${isActive(menu.link, true) ? styles['active'] : ''} `}>
                <i className={`iconfont ${menu.icon} ${styles['icon-menu']} `} />
                {menu.name}
              </div>
            </a>
          </Link>
          {
            !!(isActive(menu.link, true) && menu.items && menu.items.length)
            &&
            <ul className={styles['sub-list']}>
              {
                menu.items.map((item: any, index: number) => (
                  <li
                    className={`${styles['sub-item']} ${isActive(item.link) || item.statusID == statusID ? styles['active'] : ''}`}
                    key={index}
                    onClick={() => {
                      if (router.asPath == item.link) {
                        refreshList && refreshList();
                      }
                      router.replace(item.link, undefined, { scroll: false });
                    }}
                  >
                    {item.name}&nbsp;{`${item.key ? `(${orderCounts[item.key]})` : ''}`}
                  </li>
                ))
              }
            </ul>
          }
        </div>
      )
    }
  </div>
)